import { Component } from '@angular/core';
import { Company } from 'src/app/models/company.model';
import { Router } from '@angular/router';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.css']
})
export class AddCompanyComponent {
  [x: string]: any;
  constructor(
    
    private router: Router,
    private CompanysService: CompanysService,
    private toastr: ToastrService
  ) {}
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];

  dateNow: Date = new Date();
  IsInternal: boolean = false;

  addCompanyRequest: Company = new Company();
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (loggedInuserRole.role == 'Standard User' || loggedInuserRole.role == 'Regional User') {
      this.logout();
    }
    if (loggedInuserRole.role == 'Internal User') {
      this.IsInternal = true;
    }
    this.addCompanyRequest.Name = "";
  }

  validation() {
    let isValid = true;

      if (this.addCompanyRequest.Name == "") {
        this.NameError = true;
        isValid = false;
      } else {
        this.NameError = false;
      }
    return isValid;
  }

  addCompany() {
    const dateNowISO = this.dateNow.toISOString();

    this.addCompanyRequest.CreatedAt = dateNowISO;
    this.addCompanyRequest.UpdatedAt = dateNowISO;

    if (this.validation()) {
      this.CompanysService
      .addCompany(this.addCompanyRequest)
      .subscribe({
        next: (Company) => {
          var id = btoa(Company.Id.toString());
          this.toastr.success('Company added successfully.', 'Information');
          if (this.IsInternal) {
            this.router.navigate(['/dashboard']);
          } else {
            this.router.navigate(['/component/companies/edit/' + id]);
          }
        },
        error: (response) => {
          if (response.error.length > 0) {
            this.toastr.error(response.error, 'Error');
          } else {
            this.toastr.error('Error While Creating Company.', 'Error');
          }
        },
      });
    } else {
      this.toastr.error('Please validate all fields', 'Error');
    }
    
  }
  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}